import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { LabeledDropdown } from '../../../components/labeled-dropdown/labeled-dropdown';
import { Project } from '../../../types/entities';
import { generateProjectOptions } from '../../../utils/dropdown-options/dropdown-options';
import { DropdownLayoutOption } from '@wix/design-system';

export const TEAM_MEMBERS_FILTER_BY_PROJECT_OPTION_ALL = 'all';

interface Props {
  className?: string;
  projects: Project[];

  onSelect(projectId: string): void;
}

class TeamProjectsFilterComponent extends React.Component<
  Props & WrappedComponentProps,
  {}
> {
  public render() {
    const { className } = this.props;

    return (
      <>
        <LabeledDropdown
          className={className}
          options={this.generateProjectsOptions()}
          onSelect={this.selectProject.bind(this)}
          initialSelectedId={TEAM_MEMBERS_FILTER_BY_PROJECT_OPTION_ALL}
          width={200}
        />
      </>
    );
  }

  private selectProject(option: DropdownLayoutOption) {
    const { onSelect } = this.props;

    onSelect(option.id as string);
  }

  private generateProjectsOptions() {
    const { intl, projects } = this.props;

    const allProjectsOption = {
      id: TEAM_MEMBERS_FILTER_BY_PROJECT_OPTION_ALL,
      value: intl.formatMessage({
        id: 'team.list.header.projects-filter.options.all-projects',
      }),
    };

    return generateProjectOptions<Project>(allProjectsOption, projects);
  }
}

export const TeamProjectsFilter = injectIntl(TeamProjectsFilterComponent);
